module.exports = {"320804100":"王营镇","320804101":"赵集镇","320804102":"吴城镇","320804103":"南陈集镇","320804104":"码头镇","320804105":"王兴镇","320804106":"棉花庄镇","320804107":"丁集镇","320804108":"五里镇","320804109":"徐溜镇","320804110":"渔沟镇","320804111":"吴集镇","320804112":"西宋集镇","320804113":"三树镇","320804200":"韩桥乡","320804201":"新渡乡","320804202":"老张集乡","320804203":"凌桥乡","320804204":"袁集乡","320804205":"刘老庄乡","320804206":"古寨乡","320804400":"淮安高新技术产业开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320804.json
// module id = 825
// module chunks = 0